import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {GtProducts} from '@app/models/enums/gt-products.enum';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {GtManageOrganizationService} from '@app/services/gt-manage-organization.service';
import {environment} from '@environment';
import {Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ServiceProviderGuard implements CanActivate {
  constructor(
    private authenticationService: GtAuthenticationService,
    private manageOrganizationService: GtManageOrganizationService,
    private router: Router
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authenticationService.getSubscriptions().pipe(
      switchMap(() => {
        this.manageOrganizationService.resetManaged();
        return this.authenticationService.hasOneOf(GtProducts.VPN_SERVICE_PROVIDER_ROLE).pipe(
          map(isServiceProvider => {
            if (!isServiceProvider) {
              this.router.navigate([environment.noAccessRedirectRoute]);
              return false;
            } else if (
              state.url &&
              state.url.includes('search/organization') &&
              !this.authenticationService.organizationAccessRights.read
            ) {
              this.router.navigate([environment.noAccessRedirectRoute]);
              return false;
            } else if (state.url && state.url.includes('search/members') && !this.authenticationService.serviceAccessRights.read) {
              this.router.navigate([environment.noAccessRedirectRoute]);
              return false;
            }
            return true;
          })
        );
      })
    );
  }
}
